<template>

    <div class="h-full">

        <loading :active="componentLoading" :is-full-page="false" :can-cancel="true"></loading>

        <!--{{ comingUpItems }}-->
        <coming-up-item v-for="(contentPiece, theIndex) in comingUpItems"
            :key="theIndex"
            :currentlocale="currentlocale"
            :item="contentPiece"
            :thumbnail="regularThumbnail(contentPiece)"
            :legacy_thumbnail="legacyThumbnail(contentPiece)"
            :default_thumbnail="default_thumbnail"
        >
        </coming-up-item>

    </div>

</template>

<script>

    import Loading from 'vue-loading-overlay';

    export default {

        components: {

            Loading

        },

        props: [

            'currentlocale',
            'active_content_id',
            'default_thumbnail',
            'user'

        ],

        data() {

            return {

                componentLoading: true,

                item: this.$root.shared.playerPayload,
                comingUpItems: '',

                ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_Legacy_Thumbnails: process.env.MIX_LEGACY_THUMBNAILS_CLOUDFRONT_DNSNAME

            }

        },

        methods: {

            regularThumbnail(item) {

                return this.ENV_CloudFront_DNS_Name + item.thumbnail_url;

            },

            legacyThumbnail(item) {

                return this.ENV_CloudFront_Legacy_Thumbnails + item.thumbnail_url;

            },

        },

        created() {

            if(this.user) {

                axios.get('/api/comingup/getContent/' + this.currentlocale + '/' + this.user.id + '/' + this.active_content_id)
                    .then((response) => {

                        // We now have the "coming up" items, and we can store a copy of this collection in the shared
                        // state in order to use it for the autoplay feature, ans then proceed with normal business
                        this.$root.shared.comingUpContentCollection = response.data

                        this.comingUpItems = response.data
                        console.log(this.comingUpItems.length)


                        this.componentLoading = false

                    })
                    .catch((error) => {

                        console.log('ERROR trying to fetch Content for Coming Up Module: ' + error)

                    })

            } else {

                axios.get('/api/comingup/getContent/' + this.currentlocale + '/guest/' + this.active_content_id)
                    .then((response) => {

                        this.comingUpItems = response.data
                        console.log(this.comingUpItems.length)

                        this.componentLoading = false

                    })
                    .catch((error) => {

                        console.log('ERROR trying to fetch Content for Coming Up Module: ' + error)

                    })

            }

        }

    }

</script>
